import React from 'react';
import styles from '../styles/Projects.module.css';
import aboutStyles from '../styles/About.module.css';
import projectsData from '../data/projectsData';

function Projects() {
    return (
        <section className={styles.projectsSection} id="projects">
            <div className="container">
                <h2 className="section-title">My Projects</h2>

                <div className={styles.projectsGrid}>
                    {projectsData.map((project, index) => (
                        <div key={index} className={styles.projectCard}>
                            <img
                                src={project.image}
                                alt={project.title}
                                className={styles.projectImage}
                            />

                            <div className={styles.projectContent}>
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>

                                <div className={styles.projectTechnologies}>
                                    {project.technologies.map((tech, techIndex) => (
                                        <span key={techIndex} className={styles.techTag}>
                      {tech}
                    </span>
                                    ))}
                                </div>

                                <div className={aboutStyles.ctaButtons}>
                                    <a className={`${aboutStyles.ctaButton} ${aboutStyles.secondaryButton}`}
                                        href={project.liveLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        View Product
                                    </a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Projects;